var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.5 32.5C52.5 39.1274 47.1274 44.5 40.5 44.5C33.8726 44.5 28.5 39.1274 28.5 32.5C28.5 25.8726 33.8726 20.5 40.5 20.5C47.1274 20.5 52.5 25.8726 52.5 32.5ZM50.5 32.5C50.5 38.0228 46.0228 42.5 40.5 42.5C34.9772 42.5 30.5 38.0228 30.5 32.5C30.5 26.9772 34.9772 22.5 40.5 22.5C46.0228 22.5 50.5 26.9772 50.5 32.5Z",
    fill: "#537FF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.5 32.9305C63.5 55.5 40.5 70.5 40.5 70.5C40.5 70.5 17.5 55.5 17.5 32.9305C17.5 19.9902 27.7975 9.5 40.5 9.5C53.2025 9.5 63.5 19.9902 63.5 32.9305ZM61.5 32.9305C61.5 43.5261 56.093 52.4641 50.4949 58.8618C47.7103 62.044 44.9214 64.5474 42.8296 66.2538C41.8866 67.023 41.0883 67.6278 40.5 68.0573C39.9117 67.6278 39.1134 67.023 38.1704 66.2538C36.0786 64.5474 33.2897 62.044 30.5051 58.8618C24.907 52.4641 19.5 43.5261 19.5 32.9305C19.5 21.0596 28.9368 11.5 40.5 11.5C52.0632 11.5 61.5 21.0596 61.5 32.9305Z",
    fill: "#537FF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact2);
export default __webpack_public_path__ + "static/media/contact2.b55f0d8bd5c19258119e621e8873b8d2.svg";
export { ForwardRef as ReactComponent };